import type { TFunction } from 'i18next';
import type { FolderTree } from '~/graphql/scalars';

export const getRuleAccessLabel = (access: 'READ' | 'WRITE', t: TFunction) => {
  return t(`pages.roles.access_values.${access.toLowerCase()}`);
};

export const getDescendants = (tree: FolderTree, id: number) => {
  const getTreeNode = (treeNode: FolderTree): FolderTree | null => {
    if (treeNode.id === id) return treeNode;
    for (const child of treeNode.children) {
      const node = getTreeNode(child);
      if (node) return node;
    }
    return null;
  };

  const flatten = ({ children }: FolderTree): FolderTree[] =>
    children.reduce<FolderTree[]>((acc, node) => [...acc, node, ...flatten(node)], []);

  const treeNode = getTreeNode(tree);
  if (!treeNode) return [];

  return flatten(treeNode);
};
